/**
 * ErrorBoundary Component
 * Catches React errors and displays detailed stack trace
 */

import { Component } from 'react'
import { AlertTriangle, Copy, RefreshCw } from 'lucide-react'

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo })

    // ログ出力（開発時デバッグ用）
    console.error('ErrorBoundary caught an error:', error)
    console.error('Component stack:', errorInfo?.componentStack)
  }

  handleCopyError = () => {
    const { error, errorInfo } = this.state
    const errorText = `
Error: ${error?.message || 'Unknown error'}

Stack Trace:
${error?.stack || 'No stack trace available'}

Component Stack:
${errorInfo?.componentStack || 'No component stack available'}
    `.trim()

    navigator.clipboard.writeText(errorText).then(() => {
      alert('エラー情報をコピーしました')
    }).catch((err) => {
      console.error('Failed to copy:', err)
    })
  }

  handleReload = () => {
    window.location.reload()
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null })
  }

  render() {
    if (this.state.hasError) {
      const { error, errorInfo } = this.state

      return (
        <div className="error-boundary">
          <AlertTriangle size={48} color="var(--status-dropped)" />
          <h1 className="error-title">エラーが発生しました</h1>

          <div className="error-stack">
            <strong>Error:</strong> {error?.message || 'Unknown error'}
            {'\n\n'}
            <strong>Stack Trace:</strong>
            {'\n'}
            {error?.stack || 'No stack trace available'}
            {'\n\n'}
            <strong>Component Stack:</strong>
            {errorInfo?.componentStack || 'No component stack available'}
          </div>

          <div className="error-actions">
            <button className="btn btn-secondary" onClick={this.handleCopyError}>
              <Copy size={16} />
              Copy Error
            </button>
            <button className="btn btn-secondary" onClick={this.handleReset}>
              Try Again
            </button>
            <button className="btn btn-primary" onClick={this.handleReload}>
              <RefreshCw size={16} />
              Reload Page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
